
import { defineAsyncComponent, defineComponent, PropType } from 'vue';

import { ContentBase } from '@/models/content_base';

export default defineComponent({
  name: 'ContentCustomizing',
  components: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Content: defineAsyncComponent((): any => import('./Content.vue')),
  },
  props: {

    /**
     * キー名
     */
    keyName: {
      type: String,
      required: true,
    },

    /**
     * コンテンツ
     */
    contents: {
      type: Array as PropType<ContentBase[]>,
      required: true,
    },
  },
});
